import React from "react";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";

const Table = ({
  columns,
  sortColumn,
  onSort,
  data,
  addCheckbox,
  updateColumnList,
}) => {
  return (
    <table className="table table-sm">
      <TableHeader
        columns={columns}
        sortColumn={sortColumn}
        onSort={onSort}
        updateColumnList={updateColumnList}
      />
      <TableBody columns={columns} data={data} addCheckbox={addCheckbox} />
    </table>
  );
};

export default Table;
